module.exports = __webpack_public_path__ + "media/src/website/images/locations/kufstein/kufstein_01-eefba2038dd1dac4a87c3a5ec55f96a0.jpg";